import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';

@Directive({
  selector: '[yatCollapse]'
})
export class CollapseDirective implements OnChanges {
  @Input('yatCollapse')
  collapsed = false;

  bodyElement: HTMLElement = document.getElementsByTagName('body')[0];

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: TypedChanges<CollapseDirective>): void {
    if (changes.collapsed) {
      if (this.collapsed) {
        this.element.nativeElement.classList.remove('show');
        this.bodyElement.classList.remove('show-overlay');
      } else {
        this.element.nativeElement.classList.add('show');
        this.bodyElement.classList.add('show-overlay');
      }
    }
  }
}
